import { Avatar, Flex, UnstyledButton, useMantineTheme } from '@mantine/core'

import type { AdvisorItemProps } from '@/modules/advisorsPage/components/AdvisorItem/AdvisorItem.types'

import { Text } from '@/components/Text/Text'

import classes from './AdvisorItem.module.css'

export function AdvisorItem({
  advisor,
  onSelectAdvisor,
  selected,
}: AdvisorItemProps) {
  const theme = useMantineTheme()

  if (!advisor) return null

  const displayName = `${advisor.firstName} ${advisor.lastName}`

  return (
    <UnstyledButton onClick={() => onSelectAdvisor(advisor.id)} w="100%">
      <Flex className={`${classes.container} ${selected && classes.selected}`}>
        <Avatar
          alt={displayName}
          color={theme.other.colors.grey}
          mr={8}
          src={advisor.avatar}
        />

        <Text
          c={selected ? theme.other.colors.white : theme.other.colors.black}
        >
          {displayName}
        </Text>
      </Flex>
    </UnstyledButton>
  )
}
